import styled from "styled-components";
import { Device } from "../../../styles/screenSizes";

export const StyledNavigation = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  @media ${Device.notLaptop} {
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;
